export class Cliente {
  ID: number = 0;
  NOMBRE: string = '';
  TELEFONO: string='';
  SALDO:number=0;
  ESPECIAL:boolean=false;
}
